import { Component, OnInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sol-enterprise', templateUrl: './enterprise.component.html', styleUrls: ['./enterprise.component.scss'], standalone: false })
export class EnterpriseComponent implements OnInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-chip' },
    { id: 'outcomes', label: 'Outcomes', icon: 'bx-bar-chart-alt-2' },
  ];
  features = [
    { icon: 'bx-buildings', title: 'Multi-Tenant Architecture', desc: 'Fully isolated tenant environments with dedicated data pipelines, APIs, and dashboards per enterprise client.' },
    { icon: 'bx-lock', title: 'Enterprise SSO & RBAC', desc: 'SAML 2.0, OIDC, and granular role-based access control for seamless enterprise security integration.' },
    { icon: 'bx-server', title: 'Private Cloud Deployment', desc: 'Deploy ConnectIQ on your private cloud, on-premises, or as a dedicated hosted instance.' },
    { icon: 'bx-group', title: 'White-Label Portals', desc: 'Customer-facing and internal dashboards fully branded to your enterprise with no Varroc branding visible.' },
    { icon: 'bx-support', title: 'Dedicated SLA Support', desc: '24x7 enterprise support with dedicated account management, custom SLAs, and escalation paths.' },
    { icon: 'bx-data', title: 'Data Sovereignty', desc: 'Full control over data residency, retention, deletion, and export to meet regional compliance requirements.' },
  ];
  metrics = [
    { val: '99.99%', label: 'Enterprise Uptime SLA' },
    { val: '<4 hrs', label: 'P1 Response Time' },
    { val: '100%', label: 'Data Sovereignty' },
  ];
  ngOnInit() {}

  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
